import React from 'react';
import KickImage from 'Reuseables/KickImage';
import Styles from './NewNavbar.module.scss';
import { connect } from 'react-redux';
import { Layout } from 'antd';

const { Header } = Layout;

import { TNewNavbar } from './definitions';

import { doFetchProfile, doSignOut } from 'actions/authAction';
import HeaderRow from './Components/Organisms/HeaderRow';
import SubNavItem from './Components/Molecules/SubNavItem';
import SearchOverlay from './Components/Organisms/SearchOverlay';
import BlackOverlay from './Components/Atoms/BlackOverlay';
import { setCountDownModal, setTimer } from 'actions/menuAction';
import CountdownTimer from './Components/Organisms/CountdownTimer';
import { SidebarMenuContext } from 'Pages/Home/Context/SidebarMenuContext';

const ESCAPE_KEY = 27;

const Navbar: React.FC<TNewNavbar> = ({
  dataAuth,
  getProfile,
  logout,
  setCountdownModalState,
  countdown_modal,
  timer,
  setTimerData,
  dataCategory
}) => {
  const [showSearchOverlay, setShowSearchOverlay] = React.useState(false);

  const { toggleMenuShow } = React.useContext(SidebarMenuContext);

  React.useEffect(() => {
    if (getProfile) getProfile();
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  React.useEffect(() => {
    document.body.style.overflow = 'hidden';
    if (!showSearchOverlay) {
      document.body.style.overflow = 'unset';
    }
  }, [showSearchOverlay]);

  const handleKeyDown = (event) => {
    switch (event.keyCode) {
      case ESCAPE_KEY:
        setShowSearchOverlay(false);
        break;
      default:
        break;
    }
  };

  if (dataAuth?.userdata?.error?.status_code === 401) logout();

  return (
    <Header className={Styles['new-header']}>
      <CountdownTimer
        setCountdownModalState={setCountdownModalState}
        countdown_modal={countdown_modal}
        timer={timer}
        setTimerData={setTimerData}
      />
      <HeaderRow
        dataAuth={dataAuth}
        isSearchOverlayOpen={showSearchOverlay}
        setSearchOverlayOpen={setShowSearchOverlay}
        onClickSidebarMenu={() => toggleMenuShow(true)}
        userId={dataAuth?.userdata?.id}
      />
      <SubNavItem />
      <SearchOverlay
        show={showSearchOverlay}
        onHide={() => setShowSearchOverlay(false)}
        userId={dataAuth?.userdata?.id}
        category={dataCategory}
      />
      <BlackOverlay
        show={showSearchOverlay}
        onClick={() => setShowSearchOverlay(false)}
      />
    </Header>
  );
};

const mapStateToProps = (state) => ({
  dataAuth: state.dataAuth,
  countdown_modal: state.dataMenu.countdown_modal,
  timer: state.dataMenu.timer,
  dataCategory: state.dataCategory.selected
});

const mapDispatchToProps = (dispatch) => ({
  getProfile: () => dispatch(doFetchProfile()),
  logout: () => dispatch(doSignOut()),
  setCountdownModalState: (payload: boolean) =>
    dispatch(setCountDownModal(payload)),
  setTimerData: (payload: any) => dispatch(setTimer(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);
